import { render, staticRenderFns } from "./chat-history.vue?vue&type=template&id=717dbeeb&scoped=true"
import script from "./chat-history.vue?vue&type=script&lang=js"
export * from "./chat-history.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717dbeeb",
  null
  
)

export default component.exports